import React, { FormEvent, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import useInput from 'src/hooks/useInput';
import Input from 'src/Components/Form/Input';
import AutocompleteInput from 'src/Components/Form/AutocompleteInput';
import Button from 'src/Components/Form/Button';
import useAutocompleteInput from 'src/hooks/useAutocompleteInput';
import {
	useAddTransaction,
	useTransactionsTags,
} from 'src/hooks/queries/transactions';
import { requiredValidation } from 'src/utils/validations';
import request from 'src/utils/request';
import BackIcon from './assets/back.svg';
import AddTransactionWrapper from './styles';

const TRANSACTION_PRESETS = [
	{ title: 'سوپرمارکت', tag: 'سوپرمارکت' },
	{ title: 'کافه', tag: 'کافه' },
	{ title: 'اسنپ فود', tag: 'اسنپ فود' },
	{ title: 'شام', tag: 'اسنپ فود' },
	{ title: 'ناهار', tag: 'اسنپ فود' },
	{ title: 'بنزنین', tag: 'بنزنین' },
	{ title: 'وی‌پی‌ان', tag: 'vpn' },
	{ title: 'نان', tag: 'نان' },
];

const AddTransaction: React.FC = () => {
	const { data: tagsData } = useTransactionsTags();

	const {
		bind: bindTitleInput,
		value: title,
		setValue: setTitle,
	} = useInput({
		validations: requiredValidation,
	});
	const { bind: bindPriceInput, value: price } = useInput({
		validations: requiredValidation,
		isNumeric: true,
	});
	const {
		bind: bindTagsInput,
		value: tags,
		setValue: setTags,
	} = useAutocompleteInput({
		options: tagsData?.tags || [],
	});

	const handlePresetClick = (preset: { title: string; tag: string }) => {
		setTitle(preset.title);
		setTags(preset.tag);
	};
	const { bind: bindDescriptionInput, value: description } = useInput();

	const {
		mutate: addTransaction,
		isLoading: transactionIsLoading,
		data: transactionData,
	} = useAddTransaction();

	const { push } = useHistory();

	const handleLogin = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		request.setMonth(null);
		addTransaction({
			title,
			price,
			tags,
			description,
		});
	};

	useEffect(() => {
		if (transactionData) {
			push('/');
		}
	}, [transactionData]);

	return (
		<AddTransactionWrapper>
			<Link to='/' id='back-button'>
				<img src={BackIcon} alt='' />
			</Link>
			<h1 id='page-title'>اضافه کردن تراکنش</h1>
			<div id='transaction-presets'>
				{TRANSACTION_PRESETS.map((preset) => (
					<button
						key={preset.title}
						type='button'
						className='preset-chip'
						onClick={() => handlePresetClick(preset)}
					>
						{preset.title}
					</button>
				))}
			</div>
			<form id='add-transaction-form' onSubmit={handleLogin}>
				<Input
					type='text'
					id='title'
					label='عنوان'
					{...bindTitleInput}
				/>
				<AutocompleteInput
					type='text'
					id='tags'
					label='برچسب‌ها'
					{...bindTagsInput}
				/>
				<Input
					type='text'
					id='price'
					label='هزینه'
					{...bindPriceInput}
				/>
				<Input
					type='text'
					id='description'
					label='توضیحات'
					{...bindDescriptionInput}
				/>
				<Button
					loading={transactionIsLoading}
					type='submit'
					id='add-transaction-button'
				>
					ثبت تراکنش
				</Button>
			</form>
		</AddTransactionWrapper>
	);
};

export default AddTransaction;
